import type { ChangeRequestStatus } from 'models/service';

export const isAllowedChangeRequestStatus = ({
  allowedStatuses = ['approved', undefined],
  status,
}: {
  allowedStatuses?: Array<ChangeRequestStatus | undefined>;
  status: ChangeRequestStatus | undefined;
}) => allowedStatuses.includes(status);
